// extracted by mini-css-extract-plugin
export default {"results-block":"ResultsBlock_results-block__jZvSx","results-block__single":"ResultsBlock_results-block__single__5DE3g"};